
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 750 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0071BC","d":"M0 0h750v500H0V0z"}}),_c('g',{attrs:{"fill":"#FFF","stroke":"#000","stroke-width":"1.9"}},[_c('circle',{attrs:{"cx":"375","cy":"245","r":"225","fill":"#fff"}}),_c('circle',{attrs:{"cx":"375","cy":"245","r":"165","fill":"#0071BC"}})]),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"fill":"#8C8A8C","stroke-width":"1.9","d":"M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"}}),_c('path',{attrs:{"fill":"#FFF","stroke-width":"2","stroke-linejoin":"round","d":"M373 114l30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"}})])])
          )
        }
      }
    